import { render, staticRenderFns } from "./MirrorCommentForm.vue?vue&type=template&id=351cdf4e&scoped=true&"
import script from "./MirrorCommentForm.vue?vue&type=script&lang=js&"
export * from "./MirrorCommentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351cdf4e",
  null
  
)

export default component.exports